module.exports = __webpack_public_path__ + "img/pos5_banner.ded9c4ed.png";